import { render, staticRenderFns } from "./ColorEdit.vue?vue&type=template&id=04e1a389&"
import script from "./ColorEdit.vue?vue&type=script&lang=js&"
export * from "./ColorEdit.vue?vue&type=script&lang=js&"
import style0 from "./ColorEdit.vue?vue&type=style&index=0&id=04e1a389&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports